export default "__VITE_ASSET__CxEnAd53__"